__turbopack_context__.v({
  "avatar": "sh1-iG_avatar",
  "avatars": "sh1-iG_avatars",
  "avatarsContainer": "sh1-iG_avatarsContainer",
  "card": "sh1-iG_card",
  "description": "sh1-iG_description",
  "footer": "sh1-iG_footer",
  "footerCount": "sh1-iG_footerCount",
  "footerInfo": "sh1-iG_footerInfo",
  "footerRow": "sh1-iG_footerRow",
  "footerText": "sh1-iG_footerText",
  "headerSection": "sh1-iG_headerSection",
  "seeMore": "sh1-iG_seeMore",
  "title": "sh1-iG_title",
});
